import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

/**
 * Coding Standards
 * ===========================
 * 1. Functionality Splitting:
 *    - Create distinct, single-purpose functions to improve readability and reusability.
 * 2. Modular Imports:
 *    - Import only the required modules to reduce bundle size and enhance maintainability.
 * 3. Event Listeners:
 *    - Always wrap initialization code inside `DOMContentLoaded` to ensure the DOM is fully loaded.
 */

/* ===============================
   CONFIG & CONSTANTS
================================ */
const TYPE_PRIORITY = {
  factory: 1,
  outlets: 2,
  resellers: 3
};

STORES.forEach(store => {
  store.types = Array.isArray(store.types) ? store.types : [];
});

const FILTER_STATE = {
  keyword: '',
  type: 'all',
};

const TIMEZONES = {
  bali: 'Asia/Makassar',
  jakarta: 'Asia/Jakarta',
};

/* ===============================
   STORE MARKER & STATE
================================ */

const MARKER_SVG = `
<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="40" cy="72" rx="23" ry="3" fill="#3D3D3D"/>
<path d="M20.4667 15.4933C25.6739 10.3648 32.6913 7.49318 40 7.50001C47.32 7.50001 54.3467 10.37 59.5334 15.4933C64.23 20.1267 66.6767 25.3133 67.3234 30.7C67.9667 36.04 66.8167 41.4 64.6234 46.4267C60.27 56.4267 51.6167 65.52 43.3167 71.4367C42.3493 72.1288 41.1896 72.501 40 72.501C38.8105 72.501 37.6508 72.1288 36.6834 71.4367C28.3834 65.52 19.73 56.4233 15.3734 46.4267C13.1834 41.4 12.0367 36.04 12.6767 30.6967C13.3234 25.3133 15.77 20.13 20.4667 15.4933ZM30.8334 33.3333C30.8334 30.9022 31.7992 28.5706 33.5182 26.8515C35.2373 25.1324 37.5689 24.1667 40 24.1667C42.4312 24.1667 44.7628 25.1324 46.4819 26.8515C48.2009 28.5706 49.1667 30.9022 49.1667 33.3333C49.1667 35.7645 48.2009 38.0961 46.4819 39.8152C44.7628 41.5342 42.4312 42.5 40 42.5C37.5689 42.5 35.2373 41.5342 33.5182 39.8152C31.7992 38.0961 30.8334 35.7645 30.8334 33.3333Z" fill="#1A1A1A"/>
<path d="M47.2327 26.3761C47.0848 26.1013 46.6832 25.2791 46.3558 24.6203C45.7702 23.5737 45.1773 22.479 44.6313 21.2259C44.3314 20.328 43.6053 19.7579 42.4135 19.4831L42.3565 19.4697L42.3121 19.4313C41.7196 18.91 41.1701 18.6599 40.5837 18.6439L40.541 18.6421L40.4999 18.6429L40.4587 18.6421L40.416 18.6439C39.8296 18.6599 39.2804 18.91 38.6874 19.4313L38.6432 19.4697L38.5857 19.4831C37.394 19.7579 36.6683 20.3282 36.3676 21.2259C35.8217 22.479 35.2292 23.5737 34.6439 24.6203C34.3158 25.2794 33.9147 26.1013 33.7668 26.3761C32.2163 29.2543 30.9343 32.3787 31.0017 37.9229C31.0294 40.1875 31.5324 42.8384 32.4342 45.3188C32.7905 46.2974 33.1303 47.239 33.5395 48.1301C33.9559 48.9193 34.3635 49.6734 34.8655 50.3485C35.535 51.25 36.2787 52.0288 37.0879 52.6281C37.3708 52.8373 37.6214 53.2412 37.9119 53.7086C38.4584 54.586 39.1378 55.6791 40.2144 55.6791C40.2981 55.6791 40.384 55.6723 40.4704 55.6596L40.4999 55.6555L40.5288 55.6596C40.616 55.6723 40.7019 55.6791 40.7853 55.6791C41.8619 55.6791 42.5416 54.586 43.088 53.7086C43.3783 53.2412 43.6294 52.8373 43.912 52.6281C44.7208 52.0288 45.4645 51.25 46.1345 50.3485C46.6357 49.6734 47.0441 48.9193 47.4599 48.1301C47.8694 47.2388 48.2092 46.2971 48.565 45.3188C49.4671 42.8382 49.9701 40.1875 49.9983 37.9229C50.0654 32.3787 48.7829 29.2543 47.2327 26.3761ZM47.7202 44.7528C47.3613 45.8861 46.8698 47.0022 46.3144 48.0196C45.39 49.9281 44.1845 51.5731 42.8504 52.9311C42.7152 53.0688 42.6023 53.2768 42.4714 53.5172C42.1796 54.0545 41.8172 54.7245 40.9406 55.0473C40.8742 55.0719 40.7985 55.0915 40.7136 55.1121C40.6656 55.1243 40.614 55.1372 40.5598 55.1522L40.4999 55.17L40.4399 55.1522C40.386 55.1372 40.3341 55.1243 40.2859 55.1121C40.2015 55.0915 40.1257 55.0719 40.0594 55.0473C39.183 54.7245 38.8201 54.0545 38.5283 53.5172C38.3977 53.2768 38.2848 53.0688 38.1496 52.9311C36.8155 51.5731 35.61 49.9281 34.6851 48.0196C34.1302 47.0022 33.6384 45.8861 33.2795 44.7528C32.5958 42.5947 32.1561 40.2482 31.9962 37.8003C31.7047 33.3377 33.3326 29.2388 34.9359 25.5468C35.0826 25.2095 35.3977 24.6282 35.6115 24.2396C35.6377 24.1788 35.6649 24.1183 35.6918 24.0584C36.0992 23.1408 36.4838 22.2744 36.8315 21.427C37.0897 20.7407 37.5714 20.2388 38.2045 19.9541C38.1463 20.0108 38.0914 20.0725 38.0433 20.1407C37.0773 21.5124 35.9322 24.829 35.3988 26.8519C32.6316 37.3538 33.5072 44.1748 38.2223 51.0574C38.1989 50.5859 38.0278 50.0244 37.8227 49.5639C32.9079 38.5346 33.3171 33.9218 38.236 20.7458C38.3201 20.392 38.864 19.9315 39.3531 19.8606C38.3491 21.1586 37.2531 24.4981 36.9456 26.8044C35.7203 36.0003 35.2061 41.1581 38.2075 49.6363C38.5469 50.5953 39.2087 52.3244 39.897 53.4994C39.8134 53.2234 39.7984 52.8891 39.7132 52.5971C39.0681 50.3805 38.3201 47.7873 37.8321 45.5666C37.2664 42.9912 36.6772 40.1834 36.6543 37.6822C36.6096 32.9069 37.7569 28.337 38.9477 22.2291C39.0239 21.8372 39.8029 19.8669 39.9064 19.3931C40.0347 19.3482 40.1666 19.3179 40.2998 19.2961C40.0032 20.606 40.0772 23.8459 40.0647 27.0926C40.0599 28.2773 39.9737 29.526 40.0609 30.8021C40.3334 34.8091 40.3133 38.9077 40.3006 42.3082C40.292 44.6344 40.3301 46.4956 40.2942 48.3215C40.2554 50.3655 40.3563 52.5214 40.2996 53.3449C40.1849 54.9936 40.431 54.6675 40.5166 54.6627V54.6787C40.6025 54.6838 40.4325 54.9832 40.7342 53.3614C41.0191 51.829 40.781 47.3425 40.9197 42.6031C41.0501 38.1511 41.3249 33.476 40.9734 30.8192C40.8257 29.7097 40.9744 28.2935 40.9696 27.1086C40.9642 25.9044 40.8908 24.7863 40.8854 23.6817C40.8788 21.7973 40.903 20.1348 40.7278 19.2996C40.8549 19.3222 40.9805 19.352 41.1035 19.3954C41.2092 19.8738 41.9847 21.8375 42.0615 22.2286C43.2525 28.3362 44.399 32.9061 44.3548 37.6817C44.3314 40.1831 43.7425 42.9907 43.1767 45.5661C42.6882 47.7868 41.9405 50.38 41.2957 52.5966C41.2103 52.8886 41.1953 53.2229 41.1116 53.4989C41.8002 52.3236 42.4615 50.5945 42.8011 49.6358C45.8028 41.1576 45.2883 35.9998 44.0628 26.8039C43.7547 24.4976 42.6595 21.1581 41.6558 19.8601C42.1446 19.931 42.6882 20.3915 42.7718 20.7453C47.6912 33.9215 48.1015 38.5341 43.1866 49.5634C42.982 50.0239 42.8105 50.5854 42.7868 51.0569C47.5011 44.1743 48.377 37.3533 45.6099 26.8514C45.0764 24.8285 43.9316 21.5119 42.9658 20.1401C42.92 20.0751 42.8682 20.0156 42.8128 19.961C43.4373 20.2469 43.9125 20.7461 44.1685 21.4262C44.5164 22.2736 44.9007 23.1398 45.3082 24.0576C45.3351 24.1176 45.3626 24.1781 45.389 24.2388C45.6025 24.6274 45.9177 25.2087 46.0646 25.546C47.6681 29.238 49.2958 33.3367 49.0037 37.7996C48.8444 40.2472 48.4044 42.5939 47.7207 44.752L47.7202 44.7528Z" fill="white"/>
</svg>
`;

function createStoreIcon() {
  return L.divIcon({
    className: 'store-marker',
    html: MARKER_SVG,
    iconSize: [80, 80],
    iconAnchor: [40, 80],
    popupAnchor: [0, -40],
  });
}

const STORE_ICON = createStoreIcon();
const STORE_ICON_ACTIVE = createStoreIcon();

let activeMarker = null;
let userMarker = null;
let userCircle = null;


/* ===============================
   TIME & OPENING HOURS UTILITIES
================================ */
function parseTime24h(raw) {
  if (!raw || typeof raw !== 'string') return null;

  const parts = raw.split(':');
  if (parts.length !== 2) return null;

  const h = Number(parts[0]);
  const m = Number(parts[1]);

  if (isNaN(h) || isNaN(m)) return null;

  return { h, m };
}

function formatHours(store) {
  if (!store.open_hours || !store.close_hours) return '';
  return `${store.open_hours} - ${store.close_hours}`;
}

function isStoreOpen(store) {
  if (!store.open_hours || !store.close_hours) return null;

  const openParsed  = parseTime24h(store.open_hours);
  const closeParsed = parseTime24h(store.close_hours);

  if (!openParsed || !closeParsed) return null;

  const tz = TIMEZONES[store.city?.toLowerCase()];
  if (!tz) return null;

  // Get current time in store's timezone
  const now = new Date(
    new Date().toLocaleString('en-US', { timeZone: tz })
  );

  const open = new Date(now);
  open.setHours(openParsed.h, openParsed.m, 0, 0);

  const close = new Date(now);
  close.setHours(closeParsed.h, closeParsed.m, 0, 0);

  // Handle overnight schedule (e.g. 22:00 - 02:00)
  if (close <= open) {
    close.setDate(close.getDate() + 1);
  }

  return now >= open && now <= close;
}

function renderStatus(store) {
  const status = isStoreOpen(store);

  if (status === null) {
    return '<span class="status status--unknown"></span>';
  }

  return status
    ? `<span class="status status--open">${i18n.open}</span>`
    : `<span class="status status--closed">${i18n.closed}</span>`;
}

/* ===============================
   STORE FILTERING & LIST RENDERING
================================ */
function getFilteredStores() {
  const keyword = (FILTER_STATE.keyword || '').trim().toLowerCase();
  const type = FILTER_STATE.type || 'all';

  return STORES.filter(store => {
    const name = store.name?.toLowerCase() || '';
    const address = store.address?.toLowerCase() || '';

    const keywordMatch =
      !keyword ||
      name.includes(keyword) ||
      address.includes(keyword);

    const typeMatch = type === 'all' || store.types.includes(type);

    return keywordMatch && typeMatch;
  });
}

function getStoreLowestPriority(store) {
  return Math.min(...store.types.map(t => TYPE_PRIORITY[t] ?? 99), 99);
}

const mapEl = document.getElementById('map');

const i18n = {
  contact: mapEl.dataset.contact,
  direction: mapEl.dataset.direction,
  open: mapEl.dataset.open,
  closed: mapEl.dataset.closed
};

function createPopupContent(store) {
  const hasPhone = store.phone && store.phone.trim() !== '';
  
  return `
    <div class="store-popup">
      <button class="store-popup__close" aria-label="Close"></button>

      <h2 class="store-popup__title">${store.name}</h2>

      <div class="store-popup__meta">
        ${hasPhone ? `
          <a href="tel:${store.phone}" class="store-popup__phone">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z" fill="#1A1A1A"/>
            </svg>

            ${store.phone}
          </a>
        ` : ''}

        <span class="store-popup__status">
          ${renderStatus(store)}
          <span class="store-popup__hours">
            ${formatHours(store)}
          </span>
          
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0307 12.5306L9.53068 20.0306C9.46099 20.1002 9.37827 20.1555 9.28722 20.1932C9.19618 20.2309 9.0986 20.2503 9.00005 20.2503C8.9015 20.2503 8.80392 20.2309 8.71288 20.1932C8.62183 20.1555 8.53911 20.1002 8.46943 20.0306C8.39974 19.9609 8.34447 19.8781 8.30676 19.7871C8.26904 19.6961 8.24963 19.5985 8.24963 19.4999C8.24963 19.4014 8.26904 19.3038 8.30676 19.2128C8.34447 19.1217 8.39974 19.039 8.46943 18.9693L15.4397 11.9999L8.46943 5.03055C8.32869 4.88982 8.24963 4.69895 8.24963 4.49993C8.24963 4.30091 8.32869 4.11003 8.46943 3.9693C8.61016 3.82857 8.80103 3.74951 9.00005 3.74951C9.19907 3.74951 9.38995 3.82857 9.53068 3.9693L17.0307 11.4693C17.1004 11.539 17.1557 11.6217 17.1935 11.7127C17.2312 11.8038 17.2506 11.9014 17.2506 11.9999C17.2506 12.0985 17.2312 12.1961 17.1935 12.2871C17.1557 12.3782 17.1004 12.4609 17.0307 12.5306Z" fill="#737373"/>
          </svg>

        </span>
      </div>

      <div class="store-popup__actions">
        ${hasPhone ? `
          <a href="tel:${store.phone}" class="store-popup__btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z" fill="#1A1A1A"/>
            </svg>

            ${i18n.contact}
          </a>
        ` : ''}

        <a 
          href="https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lng}"
          target="_blank"
          class="store-popup__btn"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.12 21.75C17.52 21.75 16.91 21.61 16.33 21.32L13.09 19.7C12.41 19.36 11.59 19.36 10.9 19.7L7.65997 21.32C6.09997 22.1 4.29997 21.8 3.07997 20.55C1.85997 19.3 1.58997 17.5 2.40997 15.95L8.50997 4.36C9.18997 3.06 10.53 2.25 12 2.25C13.47 2.25 14.81 3.06 15.49 4.36L21.59 15.95C22.4 17.5 22.14 19.3 20.92 20.55C20.15 21.34 19.15 21.75 18.12 21.75ZM12 17.94C12.61 17.94 13.21 18.08 13.76 18.35L17 19.97C18.17 20.56 19.24 20.11 19.84 19.49C20.44 18.87 20.87 17.8 20.26 16.64L14.16 5.05C13.73 4.24 12.92 3.75 12 3.75C11.08 3.75 10.27 4.24 9.83997 5.06L3.73997 16.65C3.12997 17.81 3.54997 18.89 4.15997 19.5C4.76997 20.11 5.82997 20.56 6.99997 19.98L10.24 18.36C10.79 18.08 11.39 17.94 12 17.94Z" fill="#1A1A1A"/>
          </svg>

          ${i18n.direction}
        </a>
      </div>
    </div>
  `;
}



function toggleEmptyState(show) {
  const empty = document.querySelector('.store-empty');
  if (!empty) return;

  empty.classList.toggle('is-hidden', !show);
}



function renderList(map, markers) {
  const list = document.querySelector('.store-locator__store-list');
  if (!list) return;

  list.innerHTML = '';

  let filteredStores = getFilteredStores().sort((a, b) => {
    const diff = getStoreLowestPriority(a) - getStoreLowestPriority(b);
    return diff || a.name.localeCompare(b.name);
  });

  // Hide all markers
  markers.forEach(marker => map.removeLayer(marker));

  if (!filteredStores.length) {
    toggleEmptyState(true);
    return;
  }

  toggleEmptyState(false);

  filteredStores.forEach(store => {
    const item = document.createElement('div');
    item.className = 'store-locator__store-item';
    item.dataset.storeId = store.id;
    const hasPhone = store.phone && store.phone.trim() !== '';
    const typeBadges = store.types.map(t => `<span class="store-locator__store-type">${t}</span>`).join('');

    item.innerHTML = `
      <div class="store-locator__store-header">
        <h2 class="store-locator__store-name">${store.name}</h2>
        <div class="store-locator__store-types">${typeBadges}</div>
      </div>

      <p class="store-locator__store-address">${store.address}</p>

      <div class="store-locator__store-info">
        ${hasPhone ? `
          <a class="store-locator__call-wrapper" href="tel:${store.phone}">
            <span class="store-locator__call-icon"></span>
            <span class="store-locator__number">${store.phone}</span>
          </a>
        ` : ''}

        <div class="store-locator__store-status">
          ${renderStatus(store)}
          <div class="store-locator__open-hour">
            ${formatHours(store)}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.0307 12.5306L9.53068 20.0306C9.46099 20.1002 9.37827 20.1555 9.28722 20.1932C9.19618 20.2309 9.0986 20.2503 9.00005 20.2503C8.9015 20.2503 8.80392 20.2309 8.71288 20.1932C8.62183 20.1555 8.53911 20.1002 8.46943 20.0306C8.39974 19.9609 8.34447 19.8781 8.30676 19.7871C8.26904 19.6961 8.24963 19.5985 8.24963 19.4999C8.24963 19.4014 8.26904 19.3038 8.30676 19.2128C8.34447 19.1217 8.39974 19.039 8.46943 18.9693L15.4397 11.9999L8.46943 5.03055C8.32869 4.88982 8.24963 4.69895 8.24963 4.49993C8.24963 4.30091 8.32869 4.11003 8.46943 3.9693C8.61016 3.82857 8.80103 3.74951 9.00005 3.74951C9.19907 3.74951 9.38995 3.82857 9.53068 3.9693L17.0307 11.4693C17.1004 11.539 17.1557 11.6217 17.1935 11.7127C17.2312 11.8038 17.2506 11.9014 17.2506 11.9999C17.2506 12.0985 17.2312 12.1961 17.1935 12.2871C17.1557 12.3782 17.1004 12.4609 17.0307 12.5306Z" fill="currentColor"/>
            </svg>
          </div>
        </div>

      </div>
    `;

    item.addEventListener('click', () => {
      const marker = markers.get(store.id);
      if (!marker) return;

      document
        .querySelectorAll('.store-locator__store-item')
        .forEach(el => el.classList.remove('is-active'));

      item.classList.add('is-active');
      map.flyTo(marker.getLatLng(), 13);
      marker.openPopup();
    });

    list.appendChild(item);

    const marker = markers.get(store.id);
    if (marker) marker.addTo(map);
  });
}




/* ===============================
   MAP INITIALIZATION & SETUP
================================ */
function initTileLayer(map) {
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors',
  }).addTo(map);
}

function createStoreMarkers(map) {
  const markers = new Map();

  STORES.forEach(store => {
    if (!store.lat || !store.lng) return;

    const marker = L.marker(
      [store.lat, store.lng],
      { icon: STORE_ICON }
    )
    .bindPopup(createPopupContent(store), {
      closeButton: false,
      className: 'store-popup-wrapper',
      offset: [0, -20],
    });

    marker.storeId = store.id;
    marker.on('popupopen', () => handleMarkerPopupOpen(marker, map));
    marker.on('popupclose', () => handleMarkerPopupClose(marker));

    markers.set(store.id, marker);
  });

  return markers;
}

function handleMarkerPopupOpen(marker, map) {
  if (activeMarker && activeMarker !== marker) {
    activeMarker.setIcon(STORE_ICON);
  }

  marker.setIcon(STORE_ICON_ACTIVE);
  activeMarker = marker;

  // Update list item active state and scroll to it
  document
    .querySelectorAll('.store-locator__store-item')
    .forEach(el => el.classList.remove('is-active'));
  
  const storeItem = document.querySelector(
    `.store-locator__store-item[data-store-id="${marker.storeId}"]`
  );
  if (storeItem) {
    storeItem.classList.add('is-active');
    
    // Scroll the store list to show the active item
    const list = document.querySelector('.store-locator__store-list');
    if (list) {
      storeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  const targetLatLng = marker.getLatLng();
  const targetPoint = map.project(targetLatLng, 16);
  targetPoint.y -= 150;
  const targetLatLngOffset = map.unproject(targetPoint, 16);

  map.flyTo(targetLatLngOffset, 16, {
    duration: 1,
    easeLinearity: 0.25
  });
}

function handleMarkerPopupClose(marker) {
  marker.setIcon(STORE_ICON);
  activeMarker = null;

  // Remove active state from list item
  const storeItem = document.querySelector(
    `.store-locator__store-item[data-store-id="${marker.storeId}"]`
  );
  if (storeItem) {
    storeItem.classList.remove('is-active');
  }
}

function attachPopupCloseHandler(map) {
  map.on('popupopen', e => {
    const closeBtn = e.popup.getElement()
      ?.querySelector('.store-popup__close');

    if (closeBtn) {
      closeBtn.onclick = () => map.closePopup();
    }
  });
}

function initMap() {
  const map = L.map('map').setView([-8.670458, 115.212629], 13);

  initTileLayer(map);
  detectUserLocation(map);

  const markers = createStoreMarkers(map);
  attachPopupCloseHandler(map);
  addMarkersToMap(map, markers);
  
  renderList(map, markers);
  bindUI(map, markers);

  return map;
}

function addMarkersToMap(map, markers) {
  markers.forEach(marker => marker.addTo(map));
}

/* ===============================
   USER LOCATION DETECTION
================================ */
function detectUserLocation(map) {
  if (!navigator.geolocation) {
    console.warn('Geolocation not supported');
    return;
  }

  map.locate({
    setView: true,
    maxZoom: 14,
    enableHighAccuracy: true,
  });

  map.on('locationfound', (e) => {
    const { lat, lng } = e.latlng;

    // Remove previous if exists
    if (userMarker) map.removeLayer(userMarker);
    if (userCircle) map.removeLayer(userCircle);

    // Simple blue dot style marker
    userMarker = L.circleMarker([lat, lng], {
      radius: 8,
      color: '#1363DF',
      fillColor: '#1363DF',
      fillOpacity: 1,
      weight: 2,
    }).addTo(map);

    userCircle = L.circle([lat, lng], {
      radius: e.accuracy,
      color: '#1363DF',
      fillOpacity: 0.08,
    }).addTo(map);

    console.log('User location:', lat, lng);
  });

  map.on('locationerror', (err) => {
    console.warn('Location access denied:', err.message);
  });
}

/* ===============================
   UI EVENT BINDING
================================ */
function bindSearchUI(map, markers) {
  const searchInput = document.getElementById('store-search');
  const searchButton = document.querySelector('.store-locator__icon-container');

  function performSearch() {
    FILTER_STATE.keyword = searchInput.value.toLowerCase();
    renderList(map, markers);
  }

  searchButton?.addEventListener('click', performSearch);
  searchInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      performSearch();
    }
  });
}

function bindFilterUI(map, markers) {
  const filterButtons = document.querySelectorAll('.store-locator__filter');

  filterButtons.forEach(btn => {
    if (btn.dataset.type === 'all') {
      btn.classList.add('is-active');
    }

    btn.addEventListener('click', () => {
      FILTER_STATE.type = btn.dataset.type;

      filterButtons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      
      renderList(map, markers);
    });
  });
}

function bindClearFiltersUI(map, markers) {
  const clearButton = document.querySelector('[data-clear-filters]');
  const searchInput = document.getElementById('store-search');
  const filterButtons = document.querySelectorAll('.store-locator__filter');

  clearButton?.addEventListener('click', () => {
    FILTER_STATE.type = 'all';
    FILTER_STATE.keyword = '';

    if (searchInput) searchInput.value = '';
    
    filterButtons.forEach(b => b.classList.remove('is-active'));
    
    const allButton = document.querySelector(
      '.store-locator__filter[data-type="all"]'
    );
    
    allButton?.classList.add('is-active');
    renderList(map, markers);
  });
}


function bindUI(map, markers) {
  bindSearchUI(map, markers);
  bindFilterUI(map, markers);
  bindClearFiltersUI(map, markers);
}

/* ===============================
   APP INITIALIZATION
================================ */
document.addEventListener('DOMContentLoaded', initMap);
